import { render, staticRenderFns } from "./drawingBoard.vue?vue&type=template&id=143c68d8&scoped=true"
import script from "./drawingBoard.vue?vue&type=script&lang=js"
export * from "./drawingBoard.vue?vue&type=script&lang=js"
import style0 from "./drawingBoard.vue?vue&type=style&index=0&id=143c68d8&prod&scoped=true&lang=css"
import style1 from "./drawingBoard.vue?vue&type=style&index=1&id=143c68d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143c68d8",
  null
  
)

export default component.exports